import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLanding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      d="M20.498 18.424H3.478q-.19 0-.335.24a.97.97 0 0 0-.143.548q0 .31.143.55.144.24.335.239h17.044q.19 0 .335-.24.143-.237.143-.549a.87.87 0 0 0-.167-.549q-.143-.24-.335-.239M5.318 6.816l-1.53-.55 1.196 2.795 1.793 1.099q.789.454 1.65.908.884.43 1.816.788l6.048 2.173q.693.264 1.482.43.813.144 1.673.144h.335q.167-.024.335-.024a.49.49 0 0 0 .454-.335.59.59 0 0 0-.072-.62l-1.315-1.53-4.255-1.217-4.398-5.399-1.267-.477 1.96 4.777L7.28 8.63z"
    />
  </svg>
);
export default SvgLanding;
